// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// Initial State
import opState from './initialState'

// Contact us Operator
import {
  reducers as composeOperatorReducers,
} from 'hfty-operator-contact-us'

const operatorReducers = composeOperatorReducers()

// Exports
export default createReducer({
  ...opState,
}, {
  ...operatorReducers,
})
